module.exports = __webpack_public_path__ + "static/img/andon.53d86a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/andon.jpg
// module id = q6Cj
// module chunks = 1